import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABand({ onGetInfo }) {
  return (
    <section
      data-testid="cta-band"
      className="relative py-24 sm:py-32 border-t border-black/5 overflow-hidden"
    >
      <div className="absolute inset-0 grain" />
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center relative">
        <div className="overline mb-4">Ready to move?</div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#0a0a0a]">
          Your next chapter is <em className="not-italic text-[#121275]">100% yours</em>.
        </h2>
        <p className="mt-6 text-black/60 max-w-2xl mx-auto">
          Apply in 3 minutes. We'll review and personally reach out within one business day —
          no auto-responders, no funnels.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/apply" data-testid="cta-apply" className="btn-primary group">
            Apply Now
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <button onClick={onGetInfo} data-testid="cta-getinfo" className="btn-secondary">
            Just send me info
          </button>
        </div>
      </div>
    </section>
  );
}
